// Mirrors COMPANY_TYPES in shiraz-api-v2 app/main/company/_enums.js. The API stores
// and validates the display string itself, so these are the values and the labels.
const COMPANY_TYPES = ['General Contractor', 'Developer', 'Sub Contractor'];

// company_type is nullable, but Radix's Select rejects '' as an item value, so the
// "no type" option needs a sentinel that is mapped back to null on submit.
const NO_COMPANY_TYPE = '__none__';

export { COMPANY_TYPES, NO_COMPANY_TYPE };
